import React from 'react';

function FooterYiz(props){
    return(
        <div  className='container-fluid' id='footerid'><h3  className='text-center' id='txt'>
          © copyright by Yiz   &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  Yizfar@gmail.com
            </h3></div> 
    )
}

export default FooterYiz